<rask-kontrakt-search-mina-filter></rask-kontrakt-search-mina-filter>
<form [formGroup]="form" (ngSubmit)="onSearch()">
    <div class="row flex-nowrap align-items-start">
        <rask-multi-selector
            aid="inputAnsvarigVirkeskopare"
            class="col-2"
            label="Kundansvarig uppdrag"
            bindLabel="namn"
            formControlName="ansvarigVirkeskopare"
            typeToSearchText="Ange minst tre tecken"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="getAnvandareTypeAhead"
            [selected]="form.value.ansvarigVirkeskopare"></rask-multi-selector>

        <rask-multi-selector
            aid="inputAnsvarigSaljare"
            class="col-2"
            label="Kundansvarig försäljning"
            bindLabel="namn"
            formControlName="ansvarigSaljare"
            typeToSearchText="Ange minst tre tecken"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="getAnvandareTypeAhead">
        </rask-multi-selector>

        <rask-tree-selector
            class="col-2"
            label="Status"
            [items]="kontraktstatusar"
            formControlName="kontraktstatus">
        </rask-tree-selector>

        <rask-input
            aid="virkeskopKontraktSokFritext"
            class="col-2"
            label="Fritext sök"
            placeholder="Ange sökterm"
            value="sok"
            type="text"
            formControlName="sok">
        </rask-input>
    </div>

    <div class="row">
        <rask-tree-selector
            class="col-2"
            label="Planeringsstatus"
            [items]="atgardPlaneringstatusar"
            formControlName="planeringsstatus">
        </rask-tree-selector>

        <rask-tree-selector
            class="col-2"
            label="Skogsvård"
            [items]="skogsvardsItems"
            (change)="atgardsTyperChanged()"
            [autoSort]="false">
        </rask-tree-selector>
        <rask-multi-selector
            class="col-2"
            label="Skogsvårds status"
            [items]="skogsvardsStatusItems"
            bindLabel="text"
            (change)="onSkogsvardsStatusChanged($event)"
            [viewFormatter]="skogsvardViewFormatterFn"
            [selected]="skogsvardsStautsSelection">
        </rask-multi-selector>

        <rask-multi-selector
            aid="inputVirkeskopleverantor"
            class="col-2"
            label="Kund"
            formControlName="kund"
            typeToSearchText="Ange minst tre tecken"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="searchKundTypeAhead"
            [viewFormatter]="kundViewFormatter"
            [viewSelectedFormatter]="kundViewFormatter"
            [selected]="form.value.kund">
        </rask-multi-selector>

        @if(form.value.kund && form.value.kund.length > 0) {
            <rask-multi-selector
                aid="inputKontaktperson"
                class="col-2"
                label="Kontaktperson"
                bindLabel="namn"
                formControlName="kontaktperson"
                typeToSearchText="Ange minst tre tecken"
                loadingText="Laddar..."
                notFoundText="Ingen träff"
                [minTermLength]="1"
                [viewFormatter]="kontaktpersonViewFormatter"
                [viewSelectedFormatter]="kontaktpersonViewFormatter"
                [typeaheadFn]="searchForKontaktpersonTypeAhead"
                [selected]="form.value.kontaktperson">
            </rask-multi-selector>
        }
    </div>

    <div class="row">
        <div class="d-flex pt-3 col-2">
            <rask-submit-button
                aid="buttonVirkeskopKontraktSok"
                color="primary">
                Sök
            </rask-submit-button>

            <rask-button
                aid="buttonVirkeskopKontraktRensa"
                (click)="onClear()"
                negative
                color="secondary">
                Rensa
            </rask-button>
        </div>

        <div class="col-2">
            <rask-kontrakt-save-filter></rask-kontrakt-save-filter>
        </div>
    </div>
</form>